import { useState } from "react";
import { toast } from "sonner";
import { Search, Loader2 } from "lucide-react";
import Layout from "@/components/layout/Layout";
import api, { formatApiError } from "@/lib/api";
import { GreenButton } from "@/components/Buttons";

const LABELS = { pending_payment: "Awaiting payment", paid: "Paid", in_production: "In production", ready: "Ready for pickup", completed: "Completed", cancelled: "Cancelled" };

export default function TrackOrder() {
    const [num, setNum] = useState("");
    const [res, setRes] = useState(null);
    const [busy, setBusy] = useState(false);

    const lookup = async () => {
        if (!num.trim()) return;
        setBusy(true); setRes(null);
        try {
            const { data } = await api.get(`/orders/lookup/${num.trim()}`);
            setRes(data);
        } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
        finally { setBusy(false); }
    };

    return (
        <Layout hideTicker>
            <div className="mx-auto max-w-lg px-4 py-16 sm:px-6">
                <h1 className="text-center font-display text-4xl font-black tracking-tight">Track your order</h1>
                <p className="mt-2 text-center text-zinc-400">Enter your order number (e.g. 13AV-XXXXXX).</p>
                <div className="mt-8 flex gap-2">
                    <input value={num} onChange={(e) => setNum(e.target.value.toUpperCase())} onKeyDown={(e) => e.key === "Enter" && lookup()} placeholder="13AV-..." data-testid="track-input"
                        className="flex-1 rounded-full border border-white/15 bg-brand-ink px-5 py-3 font-mono text-white focus:border-brand-green focus:outline-none" />
                    <GreenButton onClick={lookup} disabled={busy} data-testid="track-button">{busy ? <Loader2 className="animate-spin" size={16} /> : <Search size={16} />}</GreenButton>
                </div>
                {res && (
                    <div className="mt-8 rounded-3xl border border-white/10 bg-white/[0.03] p-6 text-center" data-testid="track-result">
                        <p className="font-mono text-brand-green">{res.order_number}</p>
                        <div className="mt-3 inline-block rounded-full bg-brand-green/15 px-5 py-2 font-display text-xl font-bold text-brand-green">{LABELS[res.status] || res.status}</div>
                        <p className="mt-4 text-sm text-zinc-400">Placed {new Date(res.created_at).toLocaleDateString()}</p>
                    </div>
                )}
            </div>
        </Layout>
    );
}
